<template>
    <div class="muse">
        <div class="muse_box1" data-aos="fade-up">
            <p class="muse_box1_tit">剑南春酒史博物馆</p>
            <p class="muse_box1_p2">
                剑南春酒史博物馆，是由剑南春集团公司主理修建的酒类专业博物馆，馆址位于剑南春厂房建筑群落的中心轴线上，占地约4千平米，于2003年11月9日正式竣工开馆。博物馆主体分为序厅和主陈列厅两个部分，主要收藏和展示了与剑南春有关的从南齐到现代，长达1500余年以来的相关文献资料和酒史文物，共展出文物六百余件，图片、资料近百件。博物馆珍藏的遗存不仅是剑南春辉煌历史的见证，也是中国白酒行业珍贵的研究资料，为白酒文化的研究提供了宝贵的参考史料。
            </p>
        </div>
        <div class="muse_box2">
            <div class="muse_box2_con">
                <div class="b2_left" data-aos="fade-up-right">
                    <p class="ft_p1">博物馆导览</p>
                    <div class="ft_p2">
                        <p :class="dlAct==index?'dlact1':''" v-for="(item,index) in dlList" :key="index" @click="selDaoLan(index)">{{item.name}}</p>
                    </div>
                </div>
                <div class="b2_right" data-aos="fade-up-left">
                    <div class="rt_item">
                        <img :src="staticImg+dlList[dlAct].image" />
                        <div class="rt_item_text">
                            <p class="rt_text_p1">
                                {{dlList[dlAct].title}}
                            </p>
                            <p class="rt_text_p2">
                                {{dlList[dlAct].jieshao}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="muse_box3" data-aos="fade-up">
            <p class="b3_tit">馆藏精品</p>
            <div class="b3_img">
                <img src="@/images/lishi/ls_img4.png">
            </div>
            <div class="rd_box"><record></record></div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            dlAct:0,
            dlList:[],
            staticImg:this.$staticImg,
        }
    },
    created(){
        this.bwgdl();
    },
    methods:{
        // 博物馆导览
        async bwgdl() {
            const res = await this.$api.bwgdl();
            if (res.code == 1) {
                this.dlList = res.data;
            }
        },
        selDaoLan(index){
            this.dlAct=index;
        }
    }
};
</script>

<style lang="scss">
.dlact1{
    background-image: url('../../images/lishi/red3.png');
    color: #c0494b !important;
    font-weight: 700;
}
.muse {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
    margin-top: 76px;
    background-image: url("../../images/bgimg3.png");
    padding-bottom: 80px;
    min-width: 950px;
    .muse_box1 {
        padding: 65px 20px 636px;
        background-image: url("../../images/lishi/bmg3.png");
        background-repeat: no-repeat;
        background-size: auto 826px;
        background-position: bottom;
        .muse_box1_tit {
            text-align: center;
            font-size: 36px;
            color: #c0494b;
            margin-bottom: 22px;
        }
        .muse_box1_p2 {
            max-width: 918px;
            margin: 0 auto;
            color: #444;
            font-size: 16px;
            line-height: 1.7;
            text-align: center;
        }
    }
    .muse_box2 {
        background-image: url("../../images/lishi/bmg4.png");
        background-repeat: no-repeat;
        background-size: cover;
        padding: 120px 20px 150px;
        .muse_box2_con {
            max-width: 1274px;
            margin: 0 auto;
            padding-left: 80px;
            display: flex;
            justify-content: space-between;
            .b2_left {
                padding-top: 195px;
                width: 146px;
                position: relative;
                padding-left: 34px;
                box-sizing: border-box;
                .ft_p1 {
                    top: 40px;
                    position: absolute;
                    left: -78px;
                    margin: 0;
                    text-align: center;
                    font-size: 36px;
                    color: #c0494b;
                }
                .ft_p2 {
                    color: #000;
                    font-size: 18px;
                    line-height: 32px;
                    background-repeat: no-repeat;
                    background-position: 100%;
                    p {
                        margin-bottom: 46px;
                        color: #000;
                        font-size: 18px;
                        line-height: 32px;
                        background-repeat: no-repeat;
                        background-position: 100%;
                        text-align: left;
                        cursor: pointer;
                    }
                }
            }
            .b2_right {
                overflow: hidden;
                padding-left: 18px;
                flex: 1;
                .rt_item {
                    overflow: hidden;
                    position: relative;
                    .rt_item_text {
                        position: absolute;
                        left: 0;
                        z-index: 9;
                        bottom: 0;
                        right: 10px;
                        padding: 26px 60px;
                        .rt_text_p1 {
                            color: #e1e1e1;
                            font-size: 30px;
                            margin-bottom: 18px;
                            text-align: left;
                        }
                        .rt_text_p2 {
                            color: #e1e1e1;
                            font-size: 16px;
                            line-height: 1.7;
                            text-align: left;
                        }
                    }
                }
            }
        }
    }
    .muse_box3 {
        background-image: url("../../images/lishi/bmg5.png");
        border-top: 1px solid #b9b9b9;
        padding: 65px 20px 0;
        background-repeat: no-repeat;
        background-size: cover;
        .b3_tit {
            text-align: center;
            font-size: 36px;
            color: #c0494b;
            margin-bottom: 22px;
        }
        .b3_img{
            img{
                
            }
        }
    }
}
</style>